/* ============
 * Bootstrap
 * ============
 *
 * Bootstrap is an open source toolkit for developing with HTML,
 * CSS, and JS. Quickly prototype your ideas or build your entire
 * app with our Sass variables and mixins, responsive grid system,
 * extensive prebuilt components, and powerful plugins built on jQuery.
 *
 * http://getbootstrap.com/
 */
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);



// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js